/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useLogFloodgateActivity } from '@office-start/floodgate-service';
import { Page } from '@office-start/office-home-app-shared';
import React, { useCallback } from 'react';
import { NewUserShelfLazy } from '../NewUserShelf/NewUserShelfLazy';
import { CreateOnHome } from './CreateOnHome';
import { HeroComponentWrapper } from './HeroComponentWrapper';
import { LearningShelf } from './LearningShelf';
import { MyContentMigrationAnnouncementWrapper } from './MyContentMigrationAnnouncementWrapper';
import { QuickAccess } from './QuickAccess';
import { Recommended } from './Recommended';
import { StorageErrorMessageBar } from './StorageErrorMessageBar';
export var HomePage = function (setContentNode, scrollContentRef) {
    var HomePageInternal = function () {
        var logFloodgateActivity = useLogFloodgateActivity();
        var appClickHandler = useCallback(function () {
            logFloodgateActivity('HarmonyHomepageClick');
        }, [logFloodgateActivity]);
        return (React.createElement(React.Fragment, null,
            React.createElement(MyContentMigrationAnnouncementWrapper, null),
            React.createElement(Page, { name: "OfficeHome" },
                React.createElement("div", { ref: setContentNode, className: "width-restrictor--no-gutter", onClick: appClickHandler, onKeyDown: appClickHandler },
                    React.createElement(HeroComponentWrapper, null),
                    React.createElement(StorageErrorMessageBar, null),
                    React.createElement(CreateOnHome, null),
                    React.createElement(NewUserShelfLazy, null),
                    React.createElement(Recommended, null),
                    React.createElement(LearningShelf, null),
                    React.createElement(QuickAccess, null)))));
    };
    return HomePageInternal;
};
//# sourceMappingURL=HomePage.js.map